export type Kenshui30Quiz = {
  title: string;
  url: string;
};

export type Kenshui30Category = {
  title: string;
  description: string;
  articleIds: string[];
  quizList?: Kenshui30Quiz[];
};

export const kenshui30Categories: Kenshui30Category[] = [
  {
    title: '医師としての基本スキル',
    description: 'カルテ記載と患者説明の基本スキルを学ぼう',
    articleIds: [
      'd6d1a85fc84c4ddf',
      '5fee96220ee247f2',
      '33c8ecccb7604568',
      '856d2c3a93844a74',
    ],
  },
  {
    title: '検査・診断の基本',
    description: '心電図検査、レントゲン、血液ガスなどの検査を理解しよう',
    articleIds: [
      '4749b9eb2d62461e',
      '8d9a02a83243471b',
      '6ac7dc0268c54285',
      '4a7b2eea11d84e08',
      'cbe15089af3b4f4b',
    ],
  },
  {
    title: '症候・疾患アプローチ',
    description: ' 感染症診療や神経診察、頻度の多い症候の対応を学ぼう',
    articleIds: [
      'd5236d957140447d',
      'b41597a1e85041b5',
      '177c07ac93604d09',
      'e9dcd9a21832409e',
      'b56bfda9d72e4b06',
      '5ca138a7051c492d',
      '1f0d960faeee49f0',
    ],
    quizList: [
      {
        title: '神経内科医からの出題　NIHSSに関するクイズ3問、正解は？',
        url: 'https://medical.nikkeibp.co.jp/leaf/mem/doctors/cadetto/column/slide/202502/587499.html?n_cid=nbpnmo_exted_antaa',
      },
      {
        title:
          '循環器内科医からの出題　ニトログリセリンに関するクイズ2問、正解は？',
        url: 'https://medical.nikkeibp.co.jp/leaf/mem/doctors/cadetto/column/slide/202503/587922_2.html?n_cid=nbpnmo_exted_antaa',
      },
      {
        title:
          '総合診療医からの出題　感染症を引き起こす細菌に関するクイズ2問、正解は？',
        url: 'https://medical.nikkeibp.co.jp/leaf/mem/doctors/cadetto/column/slide/202408/585333.html?n_cid=nbpnmo_exted_antaa',
      },
      {
        title:
          '一般内科医からの問題　高ナトリウム血症に関するクイズ2問、正解は？',
        url: 'https://medical.nikkeibp.co.jp/leaf/mem/doctors/cadetto/column/slide/202406/584396.html?n_cid=nbpnmo_exted_antaa',
      },
    ],
  },
  {
    title: '病棟・入院管理の知識や手技',
    description: '病棟対応や各種手技や考え方を身につけよう',
    articleIds: [
      '0ad11675e6784246',
      '6bb87bfaa6714169',
      'c79ca068adba4b48',
      '54699b083b4242aa',
      '2ee856972d9240b2',
      '4a3466993f524e06',
      '02ca46dcbf2842ea',
    ],
    quizList: [
      {
        title: 'ショックのRRS対応に関するクイズ3問、正解は？',
        url: 'https://medical.nikkeibp.co.jp/leaf/mem/doctors/cadetto/column/slide/202409/585553.html?n_cid=nbpnmo_exted_antaa',
      },
    ],
  },
  {
    title: '救急外来',
    description: '救急外来・ERで求められる業務のポイントを押さえよう',
    articleIds: [
      '1f1f68752cf74ce0',
      'b8bbe797be284dce',
      'af7cce16de0c47c7',
      '452ecd0b1fb8459f',
      '7dcaf1f8145a4d9f',
    ],
  },
  {
    title: '業務スキル系',
    description: 'きっと役立つスキルを今こそ知ろう',
    articleIds: ['1efbcddcbe4d49d3', '74d7da607e644a4a'],
    quizList: [
      {
        title: '総合内科医からの出題　学会発表に関するクイズ3問、正解は？',
        url: 'https://medical.nikkeibp.co.jp/leaf/mem/doctors/cadetto/column/slide/202407/584783.html?n_cid=nbpnmo_exted_antaa',
      },
    ],
  },
];

export const kenshui30ArticleIds: string[] = kenshui30Categories.reduce(
  (arr: string[], category: Kenshui30Category) => {
    return [...arr, ...category.articleIds];
  },
  [] as string[],
);
